import { render, staticRenderFns } from "./FoldersList.vue?vue&type=template&id=3c84c23c&scoped=true&"
import script from "./FoldersList.vue?vue&type=script&lang=js&"
export * from "./FoldersList.vue?vue&type=script&lang=js&"
import style0 from "./FoldersList.vue?vue&type=style&index=0&id=3c84c23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c84c23c",
  null
  
)

export default component.exports